export default __webpack_public_path__ + "static/media/icon-activity-contentcreated.d77179f5.svg";